import type { AudioAdapter } from '@plotjack/core';
import { audio, musicForMood, type SfxId } from '../audio/engine';

/** Core's AudioAdapter backed by the baked Web Audio engine (see src/audio/engine.ts). */
export const webAudioAdapter: AudioAdapter = {
  playSfx(id: string) {
    audio.playSfx(id as SfxId);
  },
  playNarratorLine(text: string) {
    void audio.playLine(text);
  },
  setMusicMood(mood: string) {
    audio.setMusic(mood === 'title' || mood === 'ending' ? mood : musicForMood(mood));
  },
};
